// A composed disclaimer display discloses something only when it says more than "one flat
// rate on everything": extra lines, an "Up to" base, folded exclusions, or a varies program.
// Creator surfaces skip the rate breakdown entirely when neither this nor a note applies —
// the headline rate already tells the whole story.
const EXCLUSION_SUFFIX = 'exclusions apply';

const displayHasDisclosure = display => {
  const lines = display?.lines || [];
  if (!lines.length) return false;
  if (lines.length > 1) return true;
  const [line] = lines;
  if (line.type !== 'base') return true;
  return (line.rateText || line.text || '').startsWith('Up to') || (line.text || '').endsWith(EXCLUSION_SUFFIX);
};

// "Beautyblender, Ceremonia, DedCool + 7 more" under a collapsed line like "select brands".
// Capped at roughly three rendered lines; the rest fold into the "+ N more" count.
const SAMPLES_TEXT_MAX_CHARACTERS = 120;

const lineSubjectSamplesText = line => {
  const samples = line?.subjectSamples || [];
  if (!samples.length) return null;
  const shown = [];
  for (const sample of samples) {
    if (shown.length && [...shown, sample].join(', ').length > SAMPLES_TEXT_MAX_CHARACTERS) break;
    shown.push(sample);
  }
  const moreCount = (line.moreSubjectCount || 0) + (samples.length - shown.length);
  return `${shown.join(', ')}${moreCount ? ` + ${moreCount} more` : ''}`;
};

module.exports = { displayHasDisclosure, lineSubjectSamplesText };
